export default __webpack_public_path__ + "static/ch04-43772c4a54a0eb1f3ae252df7208a1d8.png";